module.exports = __webpack_public_path__ + "img/logo.360a786c.png";